module.exports = __webpack_public_path__ + "img/IMG_2254_L_WoodMatted.6d104c0e.jpg";